import React, { Fragment } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './TriggerCard.styles';
import {
  CRITERIA_OPTIONS,
  CRITERIA_TAG_OPTIONS,
  CRITERIA_TAG_PROPERTY_OPTIONS
} from '../../../../constants/triggers';

import Button from '../../../inputs/button/Button';

const TriggerCard = props => {
  return (
    <div className={css(styles.base)}>
      {props.criterias &&
        props.criterias.length &&
        props.criterias.map((criteria, index) => (
          <Fragment key={index}>
            {index > 0 && (
              <div className={css(styles.andSeparator)}>
                <Translate value="and" />
              </div>
            )}
            <div className={css(styles.text)}>
              <Translate
                value={CRITERIA_TAG_PROPERTY_OPTIONS[criteria.compareBy].text}
                type={I18n.t(CRITERIA_OPTIONS[criteria.type].label)}
                property={I18n.t(CRITERIA_TAG_OPTIONS[criteria.property].label)}
                compareBy={I18n.t(
                  CRITERIA_TAG_PROPERTY_OPTIONS[criteria.compareBy].label
                )}
                compareTo={
                  criteria.compareTo
                    ? criteria.compareTo.name || criteria.compareTo
                    : ''
                }
              />
            </div>
          </Fragment>
        ))}
      {props.showActions && (
        <div className={css(styles.buttonContainer)}>
          <Button type="button" styles={styles.button} onClick={props.onEdit}>
            <Translate value="edit.edit" />
          </Button>
          <Button type="button" styles={styles.button} onClick={props.onDelete}>
            <Translate value="delete.delete" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default TriggerCard;



// WEBPACK FOOTER //
// ./src/components/data/triggerlist/triggercard/TriggerCard.js